import { format } from 'date-fns';
const DATE_FORMAT = 'MM/dd/yyyy';

const formatUiDate = (
  dateString: string,
  dateFormat: 'MM/dd/yyyy' | 'MM.dd.yyyy' = DATE_FORMAT
) => {
  if (!dateString) return '';
  return format(new Date(dateString), dateFormat);
};
export default formatUiDate;
